import React, { useState, useEffect } from "react";
import { ChevronLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import apilink from "../apiURL/baseUrls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const MoreProfile = () => {
  const navigate = useNavigate();
  const [profileInfo, setProfileInfo] = React.useState({
    familyCode: "",
    familyName: "",
    adminName: "",
    adminEmail: "",
    adminPhone: "",
    oldpin: "",
    pin: "",
    cnpin: "",
  });
  const [postinginfo, setPostinginfo] = useState(false);
  const [postingpin, setPostingpin] = useState(false);

  const handleChangeInfo = () => {
    if (profileInfo.familyName === "") {
      toast.warn("Failed. Fill in your family name", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (profileInfo.adminName === "") {
      toast.warn("Failed. Fill in your full name", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (profileInfo.adminPhone === "") {
      toast.warn("Failed. Fill in your mobile phone number", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setPostinginfo(true);
    const dataObj = {
      familycode: profileInfo.familyCode,
      family: profileInfo.familyName,
      admin: profileInfo.adminName,
      phone: profileInfo.adminPhone
    };

    const baseUrl = apilink.link;
    axios
      .post(`${baseUrl}/family/admin/info`, dataObj)
      .then((response) => {
        
        if (response.data.message == 'Saving successfull') {
          setPostinginfo(false);
          toast.success("Saving successfull", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        } else {
          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setPostinginfo(false);
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("Error creating post", err);
      });
  };

  const handleChangePin = () => {
    if (profileInfo.oldpin === "") {
      toast.warn("Failed. Fill in your old password", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (profileInfo.pin === "") {
      toast.warn("Failed. Fill in your new password", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (profileInfo.pin !== profileInfo.cnpin) {
      toast.warn("Failed. New password is not correctly confirmed", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setPostingpin(true);
    const dataObj = {
      familycode: profileInfo.familyCode,
      oldpin: profileInfo.oldpin,
      newpin: profileInfo.pin
    };

    const baseUrl = apilink.link;
    axios
      .post(`${baseUrl}/family/admin/pin`, dataObj)
      .then((response) => {
        
        if (response.data.message == 'Saving successfull') {
          setPostingpin(false);
          setProfileInfo({ ...profileInfo, oldpin: "", pin: "", cnpin: "" });
          toast.success("Saving successfull", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        } else {
          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setPostingpin(false);
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("Error creating post", err);
      });
  };

  useEffect(() => {
    const getAsyncData = async () => {
      const storedUser = await JSON.parse(
        localStorage.getItem("userSessionData")
      );

      setProfileInfo({
        familyCode: storedUser.familycode,
        familyName: storedUser.family,
        adminName: storedUser.alias,
        adminEmail: storedUser.email,
        adminPhone: storedUser.phone,
        oldpin: "",
        pin: "",
        cnpin: "",
      });
    };
    getAsyncData();
  }, []);
  return (
    <>
      <div
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#EA6C82",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <h4 onClick={()=>navigate("/admin/more")} style={{ fontFamily: "Open Sans", fontSize: 17 }}>
          <ChevronLeft size={20} style={{ color: "#ffffff" }} />
        </h4>
        <h4 style={{ fontFamily: "Open Sans", fontSize: 17, color: "#ffffff" }}>
          <b>More /</b> Profile
        </h4>
      </div>
      {/* Reg Info */}
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <h4 style={{ fontFamily: "Open Sans", fontSize: 17 }}>
          Registration Info
        </h4>
      </div>

      <div className="row">
        <div className="col-lg-3">
          <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            Admin Email - Note that this field is not edditable
          </label>
          <br />
          <input
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginBottom: "10px",
            }}
            defaultValue={profileInfo.adminEmail}
            readOnly
          />
        </div>
        <div className="col-lg-3">
          <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            Family Name
          </label>
          <br />
          <input
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginBottom: "10px",
            }}
            value={profileInfo.familyName}
            onChange={(e) => {
              setProfileInfo({ ...profileInfo, familyName: e.target.value });
            }}
          />
        </div>
        <div className="col-lg-3">
          <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            Admin Full Name
          </label>
          <br />
          <input
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginBottom: "10px",
            }}
            value={profileInfo.adminName}
            onChange={(e) => {
              setProfileInfo({ ...profileInfo, adminName: e.target.value });
            }}
          />
        </div>

        <div className="col-lg-3">
          <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            Admin Phone
          </label>
          <br />
          <input
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginBottom: "10px",
            }}
            value={profileInfo.adminPhone}
            onChange={(e) => {
              setProfileInfo({ ...profileInfo, adminPhone: e.target.value });
            }}
          />
        </div>
      </div>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "17px",
        }}
      >
        <button
        onClick={(e) => {
          handleChangeInfo();
        }}
          style={{
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            border: "none",
            height: 40,
            fontFamily: "Open Sans",
            paddingInline: 14,
            fontSize: 14,
            color: "white",
            width: "140px",
          }}
        >
          {postinginfo === false && <>Update Info</>}
            {postinginfo && (
              <>
                <Squares />
              </>
            )}
        </button>
      </div>

      {/* Change Pin*/}
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <h4 style={{ fontFamily: "Open Sans", fontSize: 17 }}>
          Change Password
        </h4>
      </div>

      <div className="row">
        <div className="col-lg-3">
          <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            Old Password
          </label>
          <br />
          <input
            type="password"
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginBottom: "10px",
            }}
            value={profileInfo.oldpin}
            onChange={(e) => {
              setProfileInfo({ ...profileInfo, oldpin: e.target.value });
            }}
          />
        </div>
        <div className="col-lg-3">
          <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            New Password
          </label>
          <br />
          <input
          type="password"
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginBottom: "10px",
            }}
            value={profileInfo.pin}
            onChange={(e) => {
              setProfileInfo({ ...profileInfo, pin: e.target.value });
            }}
          />
        </div>
        <div className="col-lg-3">
          <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            Confirm New Password
          </label>
          <br />
          <input
          type="password"
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginBottom: "10px",
            }}
            value={profileInfo.cnpin}
            onChange={(e) => {
              setProfileInfo({ ...profileInfo, cnpin: e.target.value });
            }}
          />
        </div>
        <div
          className="col-lg-3"
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "30px",
          }}
        >
          <button
            onClick={(e) => {
              handleChangePin();
            }}
            style={{
              backgroundColor: "#EA6C82",
              borderRadius: 5,
              border: "none",
              height: 40,
              fontFamily: "Open Sans",
              paddingInline: 14,
              fontSize: 14,
              color: "white",
              width: "140px",
            }}
          >
            {postingpin === false && <>Update Info</>}
            {postingpin && (
              <>
                <Squares />
              </>
            )}
          </button>
        </div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default MoreProfile;
